import { Dropdown, Input, Select } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import CaretDownIcon from "../../../../assets/icons/CaretDownIcon";
import GridViewIcon from "../../../../assets/icons/GridViewIcon";
import ListViewIcon from "../../../../assets/icons/ListViewIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ThreeDotsIcon from "../../../../assets/icons/ThreeDotsIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import EmptySvg from "../../../../assets/images/empty.svg";
import CustomPagination from "../../../../components/ui/CustomPagination";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetApprovalHubTicketsQuery } from "../../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import {
  GetApprovalHubTicketsParamsType,
  GetApprovalHubTicketsResponseType,
} from "../../../../types/tickets";
import { capitalize, formatValue } from "../../../../utils/string";
import { addKeyInArray, formatSLA } from "../../../../utils/utils";
import { TEMPLATE_TYPES } from "../constants/ticket.constants";
import AssignedTicketCard from "./_components/AssignedTicketCard";
import { PRIORITY_CONFIG } from "./AllTickets";

export const STATUS_CONFIG = {
  "SLA Breached": "text-[#FF3838] bg-[#FFF5F4]",
  Resolved: "text-[#11A75C] bg-[#F2FFF9]",
  active: "text-[#11A75C] bg-[#F2FFF9]",
  Active: "text-[#11A75C] bg-[#F2FFF9]",
  Closed: "text-[#11A75C] bg-[#F2FFF9]",
  Forwarded: "text-[#820BF4] bg-[#F5ECFE]",
  Passed: "text-[#820BF4] bg-[#F5ECFE]",
  passed: "text-[#820BF4] bg-[#F5ECFE]",
  pending: "text-[#FC8415] bg-[#FFF6ED]",
  Pending: "text-[#FC8415] bg-[#FFF6ED]",
  Completed: "status-success",
};

export default function AssignToMe() {
  const [layout, setLayout] = useState<"grid" | "list">(
    (localStorage.getItem("assign_to_me_layout") as "grid" | "list") || "list",
  );
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetApprovalHubTicketsParamsType>({
    defaultFilter: {
      ticket_type: "",
      status: "all",
    },
  });

  // const { handleOpen, handleClose, open } = useModal<
  //   any | undefined,
  //   "UPDATE"
  // >();

  const user = useAppSelector((state) => state.auth);
  const userRole = useAppSelector((state) => state.auth.role);

  const {
    isLoading,
    isFetching,
    isError,
    error,
    data: approvalHubTicketsData,
  } = useGetApprovalHubTicketsQuery(
    {
      params: {
        ...filter,
        skip: undefined,
        search: keyword,
        page,
        id: user?.user?.id,
        ticket_type: filter.ticket_type,
        status: filter.status,
      },
    },
    { skip: !user?.user?.id },
  );
  useError(isError, error, "Get approval hub tickets list fail");

  const approvalHubTicketsAllData = approvalHubTicketsData?.data?.ticketLogs;

  const columns: ColumnsType<GetApprovalHubTicketsResponseType> = [
    {
      title: "Ticket name",
      width: 200,
      dataIndex: "title",
      render: (val) => {
        return <span className="block min-w-[100px]">{val}</span>;
      },
    },
    {
      title: "Ticket ID",
      align: "center",
      render: (val) => (
        <Link
          className="text-nowrap"
          to={`${
            userRole === "super_admin" || userRole === "Admin"
              ? "/admin"
              : "/user"
          }/ticket-management/approval-hub/approver-details/${
            val?.generated_ticket_log_id
          }`}
        >
          {val?.generated_ticket_log_id ?? "N/A"}
        </Link>
      ),
    },
    {
      title: "SLA",
      dataIndex: "totalSLA",
      align: "center",
      render: (val) => {
        return (
          <span className="text-[#EB7101] bg-[#FFF6ED] py-1 px-2 text-[12px] rounded-full text-nowrap">
            {formatSLA(val)}
          </span>
        );
      },
    },
    {
      title: "My Role",
      dataIndex: "role_type",
      align: "center",
      render: (val) => (
        <span
          className={`rounded-full py-1 px-2 text-[12px] text-[#1580CD] bg-[#F3FAFF] text-nowrap`}
        >
          {capitalize(val)}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",

      render: (val) => (
        <span
          className={`rounded-full py-1 px-2 text-[12px] ${
            val === TEMPLATE_TYPES.sla
              ? "text-[#1580CD] bg-[#E4F4FF]"
              : "text-[#820BF4] bg-[#F5ECFE]"
          }`}
        >
          {val === TEMPLATE_TYPES.sla ? "SLA Based" : "Workflow Based"}
        </span>
      ),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      align: "center",
      render: (val) => (
        <span
          className={
            PRIORITY_CONFIG?.[val as keyof typeof PRIORITY_CONFIG].className
          }
        >
          {formatValue(
            PRIORITY_CONFIG?.[val as keyof typeof PRIORITY_CONFIG].title,
          )}
        </span>
      ),
    },
    {
      title: "Severity",
      dataIndex: "severity",
      align: "center",
      render: (val) => (
        <span className="status status-orange">
          {formatValue(capitalize(val))}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",

      render: (val) => {
        return (
          <span
            className={`rounded-full py-1 px-2 text-[12px] text-nowrap ${
              STATUS_CONFIG?.[val as keyof typeof STATUS_CONFIG]
            }`}
          >
            {val === "pending" || val === "passed" ? capitalize(val) : val}
          </span>
        );
      },
    },
    {
      title: "Action",
      render: (val) => {
        return (
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <Link
                      to={`${
                        userRole === "super_admin" ? "/admin" : "/user"
                      }/ticket-management/approval-hub/approver-details/${
                        val?.generated_ticket_log_id
                      }`}
                    >
                      <div className="flex gap-2 items-center">
                        <span>
                          <ViewIcon />
                        </span>
                        <span>View Details</span>
                      </div>
                    </Link>
                  ),
                  key: "1",
                },
                // ...(val?.workflow_status !== "canceled" &&
                // val?.workflow_status !== "completed" &&
                // val?.workflow_status !== "closed"
                //   ? [
                //       {
                //         label: (
                //           <div
                //             className="flex gap-2 items-center"
                //             onClick={() =>
                //               handleOpen({
                //                 type: "UPDATE",
                //                 data: {
                //                   id: val.id,
                //                   priority: val.priority,
                //                 },
                //               })
                //             }
                //           >
                //             <span>
                //               <ShiftPriorityIcon />
                //             </span>
                //             <span>Shift Priority </span>
                //           </div>
                //         ),
                //         key: "3",
                //       },
                //     ]
                //   : []),
              ],
            }}
            trigger={["click"]}
          >
            <div className="cursor-pointer">
              <ThreeDotsIcon />
            </div>
          </Dropdown>
        );
      },
    },
  ];
  useEffect(() => {
    localStorage.setItem("assign_to_me_layout", layout);
  }, [layout]);
  return (
    <SidebarLayout title="Ticket Management">
      {/* {open.type === "UPDATE" && (
        <ShiftPriorityModal
          open={open.open}
          handleClose={handleClose}
          data={open.data}
        />
      )} */}
      <div className="flex justify-between items-center flex-wrap">
        <div className="flex gap-2 items-center mb-2">
          <div>Total Rows</div>
          <Select
            placeholder="10"
            suffixIcon={<CaretDownIcon />}
            size="middle"
            style={{ width: 70 }}
            onChange={handleLimit}
            options={[
              { label: "10", value: 10 },
              { label: "20", value: 20 },
              { label: "50", value: 50 },
              { label: "100", value: 100 },
              { label: "1000", value: 1000 },
            ]}
          />
          <div>of {approvalHubTicketsData?.data?.totalLength || 0}</div>
        </div>
        <div className="flex gap-2 items-center flex-wrap">
          <Input
            placeholder="Search by Name, Id"
            suffix={<SearchIcon />}
            size="middle"
            className="max-w-[200px]"
            onChange={handleSearch}
            allowClear
          />

          <Select
            placeholder="Role"
            allowClear
            suffixIcon={<CaretDownIcon />}
            size="middle"
            style={{ width: 100 }}
            value={filter?.role ?? undefined}
            onChange={(value) => handleFilter("role", value)}
            options={[
              { label: "Approver", value: "approver" },
              { label: "Checker", value: "checker" },
              { label: "Executor", value: "executor" },
              { label: "CC", value: "cc" },
            ]}
          />
          <Select
            placeholder="Priority"
            suffixIcon={<CaretDownIcon />}
            size="middle"
            style={{ width: 100 }}
            value={filter?.priority ?? undefined}
            onChange={(value) => handleFilter("priority", value)}
            options={[
              {
                value: "critical",
                label: "P1",
              },
              {
                value: "major",
                label: "P2",
              },
              {
                value: "moderate",
                label: "P3",
              },
              {
                value: "minor",
                label: "P4",
              },
            ]}
            allowClear
          />
          <Select
            placeholder="Severity"
            suffixIcon={<CaretDownIcon />}
            style={{ width: 100 }}
            size="middle"
            value={filter?.severity ?? undefined}
            onChange={(value) => handleFilter("severity", value)}
            options={[
              { label: "S1", value: "s1" },
              { label: "S2", value: "s2" },
              { label: "S3", value: "s3" },
              { label: "S4", value: "s4" },
            ]}
            allowClear
          />
          <Select
            placeholder="Type"
            suffixIcon={<CaretDownIcon />}
            size="middle"
            style={{ width: 150 }}
            value={filter?.ticket_type ?? undefined}
            onChange={(value) => handleFilter("ticket_type", value)}
            options={[
              { label: "All", value: "" },
              { label: "SLA Based", value: TEMPLATE_TYPES.sla },
              { label: "Workflow Based", value: TEMPLATE_TYPES.workflow },
            ]}
            allowClear
          />
          <div
            className={`cursor-pointer ${
              layout === "grid" ? "text-[#FE7235]" : ""
            } `}
            onClick={() => setLayout("grid")}
          >
            <GridViewIcon />
          </div>
          <div
            className={`cursor-pointer ${
              layout === "list" ? "text-[#FE7235]" : ""
            } `}
            onClick={() => setLayout("list")}
          >
            <ListViewIcon />
          </div>
        </div>
      </div>

      {layout === "grid" && (
        <>
          {approvalHubTicketsAllData?.length !== 0 ? (
            <>
              <div className="grid mt-4 xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
                {approvalHubTicketsAllData?.map((ticket) => (
                  <AssignedTicketCard key={ticket.id} ticket={ticket} />
                ))}
              </div>

              <CustomPagination
                total={approvalHubTicketsData?.data?.totalLength || 0}
                limit={limit}
                page={page}
                handlePagination={handlePagination}
              />
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                }}
              >
                <img src={EmptySvg} alt="empty_image" />
              </div>
            </>
          )}
        </>
      )}

      {layout === "list" && (
        <div className="mt-4">
          <CustomTable
            loading={isLoading || isFetching}
            limit={limit}
            page={page}
            columns={columns}
            handlePagination={handlePagination}
            total={approvalHubTicketsData?.data?.totalLength}
            dataSource={addKeyInArray(approvalHubTicketsAllData)}
          />
        </div>
      )}
    </SidebarLayout>
  );
}
